import React from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../../firebase/firebase";
import { signOut } from "firebase/auth";

export default function AdminNavBar() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/admin/login");
    } catch (err) {
      console.error("Logout error:", err);
    }
  };

  return (
    <div className="admin-header">
      <div className="admin-header-left">
        <h2>Admin Panel</h2>
      </div>

      <div className="admin-header-actions">
        <button onClick={() => navigate("/")}>Home</button>
        <button onClick={() => navigate("/admin/dashboard")}>Dashboard</button>
        <button onClick={() => navigate("/admin/update")}>Updates</button>
        <button onClick={() => navigate("/admin/upload")}>Upload</button>
        <button onClick={() => navigate("/admin/edit")}>Edit Products</button>
        <button onClick={() => navigate("/admin/categories")}>Categories</button>
        <button className="logout-btn" onClick={handleLogout}>Log Out</button>
      </div>
    </div>
  );
}
